export default __webpack_public_path__ + "static/26-3c32ae9031a001bc9e0552f5c7a257ae.jpg";